import React, { useState } from 'react';

// Orden recomendado de migración a Tailwind + librerías visuales
const migrationGroups = [
  {
    title: 'Configuración y estilos globales',
    items: [
      { label: 'Instalar y configurar Tailwind', path: 'tailwind.config.js', prompt: 'Instala y configura Tailwind CSS en mi proyecto React con Vite.' },
      { label: 'Instalar y configurar shadcn/ui', path: 'shadcn-ui', prompt: 'Instala y configura shadcn/ui en mi proyecto React con Tailwind.' },
      { label: 'Instalar y configurar Framer Motion', path: 'framer-motion', prompt: 'Instala y configura Framer Motion en mi proyecto React para animaciones.' },
      { label: 'Instalar y configurar Headless UI', path: 'headless-ui', prompt: 'Instala y configura Headless UI en mi proyecto React con Tailwind.' },
      { label: 'Instalar y configurar un plugin de gradientes o glassmorphism', path: 'tailwindcss-gradients', prompt: 'Instala y configura un plugin de Tailwind para gradientes o glassmorphism (por ejemplo, tailwindcss-gradients o tailwindcss-glassmorphism).' },
      { label: 'index.css', path: 'src/index.css', prompt: 'Migra los estilos globales de src/index.css a utilidades de Tailwind.' },
      { label: 'App.css', path: 'src/App.css', prompt: 'Migra los estilos globales de src/App.css a utilidades de Tailwind.' },
    ],
  },
  {
    title: 'Archivos de estilos compartidos y módulos',
    items: [
      { label: 'Steps.css (OnBoarding)', path: 'src/components/OnBoarding/Steps.css', prompt: 'Migra los estilos de src/components/OnBoarding/Steps.css a clases de Tailwind.' },
      { label: 'CertificationsCard.css (WorkerDashboard)', path: 'src/components/WorkerDashboard/CertificationsCard.css', prompt: 'Migra los estilos de src/components/WorkerDashboard/CertificationsCard.css a clases de Tailwind.' },
      { label: 'WorkerDashboard.module.css', path: 'src/components/WorkerDashboard.module.css', prompt: 'Migra los estilos de src/components/WorkerDashboard.module.css a clases de Tailwind.' },
      { label: 'Admin.css', path: 'src/pages/Admin/Admin.css', prompt: 'Migra los estilos de src/pages/Admin/Admin.css a clases de Tailwind.' },
      { label: 'SkillsManagement.css', path: 'src/pages/Admin/SkillsManagement.css', prompt: 'Migra los estilos de src/pages/Admin/SkillsManagement.css a clases de Tailwind.' },
      { label: 'BusinessDashboard.css', path: 'src/pages/BusinessDashboard/BusinessDashboard.css', prompt: 'Migra los estilos de src/pages/BusinessDashboard/BusinessDashboard.css a clases de Tailwind.' },
      { label: 'MyCertifications.css', path: 'src/pages/MyCertifications.css', prompt: 'Migra los estilos de src/pages/MyCertifications.css a clases de Tailwind.' },
    ],
  },
  {
    title: 'Componentes UI reutilizables',
    items: [
      { label: 'DynamicIslandMenu', path: 'src/components/DynamicIslandMenu.tsx', prompt: 'Migra el componente DynamicIslandMenu a Tailwind.' },
      { label: 'Menu', path: 'src/components/Menu.tsx', prompt: 'Migra el componente Menu a Tailwind.' },
      { label: 'LanguageSelector', path: 'src/components/LanguageSelector.tsx', prompt: 'Migra el componente LanguageSelector a Tailwind.' },
      { label: 'HoneycombBackground', path: 'src/components/HoneycombBackground.tsx', prompt: 'Migra el componente HoneycombBackground a Tailwind.' },
      { label: 'TodoList', path: 'src/components/TodoList.tsx', prompt: 'Migra el componente TodoList a Tailwind.' },
    ],
  },
  {
    title: 'Componentes de autenticación',
    items: [
      { label: 'AuthPage', path: 'src/components/Auth/AuthPage.tsx', prompt: 'Migra el componente AuthPage a Tailwind.' },
      { label: 'Login (Auth)', path: 'src/components/Auth/Login.tsx', prompt: 'Migra el componente Login (Auth) a Tailwind.' },
      { label: 'Register (Auth)', path: 'src/components/Auth/Register.tsx', prompt: 'Migra el componente Register (Auth) a Tailwind.' },
      { label: 'BusinessRegister (Auth)', path: 'src/components/Auth/BusinessRegister.tsx', prompt: 'Migra el componente BusinessRegister (Auth) a Tailwind.' },
      { label: 'ForgotPassword (Auth)', path: 'src/components/Auth/ForgotPassword.tsx', prompt: 'Migra el componente ForgotPassword (Auth) a Tailwind.' },
      { label: 'HoneycombBackground (Auth)', path: 'src/components/Auth/HoneycombBackground.tsx', prompt: 'Migra el componente HoneycombBackground (Auth) a Tailwind.' },
    ],
  },
  {
    title: 'Componentes de OnBoarding',
    items: [
      { label: 'OnBoardingFlow', path: 'src/components/OnBoarding/OnBoardingFlow.tsx', prompt: 'Migra el componente OnBoardingFlow a Tailwind.' },
      { label: 'Step1CompleteId', path: 'src/components/OnBoarding/Step1CompleteId.tsx', prompt: 'Migra el componente Step1CompleteId a Tailwind.' },
      { label: 'Step2Address', path: 'src/components/OnBoarding/Step2Address.tsx', prompt: 'Migra el componente Step2Address a Tailwind.' },
      { label: 'Step3Experience', path: 'src/components/OnBoarding/Step3Experience.tsx', prompt: 'Migra el componente Step3Experience a Tailwind.' },
      { label: 'Step4Photo', path: 'src/components/OnBoarding/Step4Photo.tsx', prompt: 'Migra el componente Step4Photo a Tailwind.' },
      { label: 'Step4ProfilePhoto', path: 'src/components/OnBoarding/Step4ProfilePhoto.tsx', prompt: 'Migra el componente Step4ProfilePhoto a Tailwind.' },
      { label: 'Step5Certifications', path: 'src/components/OnBoarding/Step5Certifications.tsx', prompt: 'Migra el componente Step5Certifications a Tailwind.' },
    ],
  },
  {
    title: 'Componentes de Dashboard y protegidos',
    items: [
      { label: 'AdminDashboard', path: 'src/components/AdminDashboard.tsx', prompt: 'Migra el componente AdminDashboard a Tailwind.' },
      { label: 'WorkerDashboard', path: 'src/components/WorkerDashboard.tsx', prompt: 'Migra el componente WorkerDashboard a Tailwind.' },
      { label: 'CertificationsCard', path: 'src/components/WorkerDashboard/CertificationsCard.tsx', prompt: 'Migra el componente CertificationsCard a Tailwind.' },
      { label: 'BusinessRoute', path: 'src/components/ProtectedRoute/BusinessRoute.tsx', prompt: 'Migra el componente BusinessRoute a Tailwind.' },
    ],
  },
  {
    title: 'Páginas principales (rutas)',
    items: [
      { label: 'Login', path: '/auth/login', prompt: 'Migra la página /auth/login a Tailwind.' },
      { label: 'Registro de usuario', path: '/auth/register', prompt: 'Migra la página /auth/register a Tailwind.' },
      { label: 'Registro de negocio', path: '/auth/business-register', prompt: 'Migra la página /auth/business-register a Tailwind.' },
      { label: 'Recuperar contraseña', path: '/auth/forgot-password', prompt: 'Migra la página /auth/forgot-password a Tailwind.' },
      { label: 'OnBoarding', path: '/onboarding', prompt: 'Migra la página /onboarding a Tailwind.' },
      { label: 'Dashboard de trabajador', path: '/worker-dashboard', prompt: 'Migra la página /worker-dashboard a Tailwind.' },
      { label: 'Dashboard de administrador', path: '/admin-dashboard', prompt: 'Migra la página /admin-dashboard a Tailwind.' },
      { label: 'Dashboard de negocio', path: '/business/dashboard', prompt: 'Migra la página /business/dashboard a Tailwind.' },
      { label: 'Gestión de habilidades', path: '/admin/skills', prompt: 'Migra la página /admin/skills a Tailwind.' },
      { label: 'Gestión de contraseñas de usuarios', path: '/admin/user-passwords', prompt: 'Migra la página /admin/user-passwords a Tailwind.' },
      { label: 'Proceso de aprobación', path: '/admin/approval-process', prompt: 'Migra la página /admin/approval-process a Tailwind.' },
      { label: 'Perfil de negocio', path: '/business/company', prompt: 'Migra la página /business/company a Tailwind.' },
      { label: 'Mis certificaciones', path: '/my-certifications', prompt: 'Migra la página /my-certifications a Tailwind.' },
      { label: 'Balance', path: '/balance', prompt: 'Migra la página /balance a Tailwind.' },
      { label: 'Cotizaciones', path: '/quotations', prompt: 'Migra la página /quotations a Tailwind.' },
      { label: 'Detalle de cotización', path: '/quotations/:quotationId', prompt: 'Migra la página /quotations/:quotationId a Tailwind.' },
      { label: 'Proyectos', path: '/projects', prompt: 'Migra la página /projects a Tailwind.' },
      { label: 'Detalle de proyecto', path: '/projects/:projectId', prompt: 'Migra la página /projects/:projectId a Tailwind.' },
      { label: 'Formulario de cotización público', path: '/quotation-form/:businessId', prompt: 'Migra la página /quotation-form/:businessId a Tailwind.' },
      { label: 'Formulario de cotización público v2', path: '/quotation-form-v2/:businessId', prompt: 'Migra la página /quotation-form-v2/:businessId a Tailwind.' },
      { label: 'Página de agradecimiento', path: '/thank-you', prompt: 'Migra la página /thank-you a Tailwind.' },
    ],
  },
];

const flatItems = migrationGroups.flatMap(group => group.items);

const MigrationChecklist: React.FC = () => {
  const [checked, setChecked] = useState(Array(flatItems.length).fill(false));
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  const [copiedIdx, setCopiedIdx] = useState<number | null>(null);

  const handleCheck = (idx: number) => {
    setChecked(prev => {
      const copy = [...prev];
      copy[idx] = !copy[idx];
      return copy;
    });
  };

  const handleCopy = async (prompt: string, idx: number) => {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx(null), 1200);
    } catch (e) {
      alert('No se pudo copiar al portapapeles');
    }
  };

  let itemIdx = 0;

  return (
    <div style={{ maxWidth: 700, margin: '2rem auto', padding: '2rem', background: '#fff', borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
      <h2 style={{ marginBottom: '1.5rem', color: '#d60e3c' }}>Checklist de migración a Tailwind</h2>
      {migrationGroups.map((group) => (
        <div key={group.title} style={{ marginBottom: 32 }}>
          <h3 style={{ color: '#4A90E2', marginBottom: 12 }}>{group.title}</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {group.items.map((item) => {
              const globalIdx = itemIdx;
              itemIdx++;
              const isOpen = openIdx === globalIdx;
              return (
                <li key={item.path} style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpenIdx(isOpen ? null : globalIdx)}>
                    <input
                      type="checkbox"
                      checked={checked[globalIdx]}
                      onChange={e => { e.stopPropagation(); handleCheck(globalIdx); }}
                      style={{ marginRight: 12 }}
                      onClick={e => e.stopPropagation()}
                    />
                    <span>{item.label} <span style={{ color: '#888', fontSize: 13 }}>({item.path})</span></span>
                    <span style={{ marginLeft: 'auto', color: '#aaa', fontSize: 18 }}>{isOpen ? '▲' : '▼'}</span>
                  </div>
                  {isOpen && (
                    <div style={{ background: '#f9f9f9', borderRadius: 8, marginTop: 6, padding: 12, fontSize: 14, color: '#333', border: '1px solid #eee', position: 'relative' }}>
                      <strong>Prompt sugerido:</strong><br />
                      <code style={{ background: '#f3f3f3', padding: '2px 6px', borderRadius: 4 }}>{item.prompt}</code>
                      <button
                        onClick={e => { e.stopPropagation(); handleCopy(item.prompt, globalIdx); }}
                        style={{ marginLeft: 12, padding: '2px 10px', borderRadius: 4, border: 'none', background: '#d60e3c', color: '#fff', cursor: 'pointer', fontSize: 13 }}
                      >
                        {copiedIdx === globalIdx ? '¡Copiado!' : 'Copiar'}
                      </button>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
      <div style={{ marginTop: 32, fontSize: 15, color: '#333' }}>
        <strong>URL sugerida para acceder a este checklist:</strong><br />
        <code style={{ background: '#f3f3f3', padding: '2px 6px', borderRadius: 4 }}>/migration</code>
      </div>
    </div>
  );
};

export default MigrationChecklist; 